<template>
	<div>
		<slot
			v-bind="{
				formattedString,
				text,
				maxChars,
				isReadMore,
				handleClick,
				trigger,
			}"
		>
			<p
				:style="{ 'margin-bottom': $vuetify.display.xsOnly ? 0 : '16px' }"
				class="readMoreText ql-editor"
				v-html="trigger && isReadMore ? text : formattedString"
			></p>
			<span v-show="text.length > maxChars && maxChars > 0" class="readMoreLink"
				><a
					v-if="to === '#'"
					v-show="!isReadMore || trigger"
					id="readmore"
					@click="handleClick"
				>
					<v-icon
						:icon="isReadMore ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
						class="mr-1"
					></v-icon>
					{{ !isReadMore ? moreStr : t('common.hide') }}</a
				>
				<router-link v-else :to="to" class="text-decoration-none">{{
					moreStr
				}}</router-link>
			</span>
		</slot>
	</div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n'

export default {
	props: {
		lessStr: {
			type: String,
			default: '',
		},
		maxChars: {
			type: Number,
			default: 100,
		},
		moreStr: {
			type: String,
			default: () => useI18n().t('common.readMore'),
		},
		text: {
			type: String,
			required: true,
		},
		to: {
			default: '#',
			type: [Object, String],
			required: false,
		},
		trigger: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isReadMore: false,
			t: useI18n().t,
		}
	},
	computed: {
		formattedString() {
			let val_container = this.text
			if (
				!this.isReadMore &&
				this.text?.length > this.maxChars &&
				this.maxChars > 0
			) {
				val_container = val_container.substring(0, this.maxChars) + '...'
			}
			return val_container
		},
	},
	methods: {
		handleClick(event) {
			if (this.trigger) {
				this.triggerReadMore(event, !this.isReadMore)
			} else {
				this.$emit('click')
			}
		},
		triggerReadMore(e, b) {
			if (this.to === '#') {
				e.preventDefault()
			}
			if (this.lessStr !== null || this.lessStr !== '') this.isReadMore = b
		},
	},
}
</script>

<style lang="scss">
.readMoreLink {
	display: inline;
	padding-left: 3px;
}

// Quill's .ql-editor adds 12px/15px padding meant for the edit surface.
// In read-only display this indents the text away from its container; remove
// the horizontal padding so ReadMore content aligns flush with sibling fields.
.readMoreText.ql-editor {
	padding-left: 0;
	padding-right: 0;
}
</style>
